// extracted by mini-css-extract-plugin
module.exports = {"stop":"stop-3bmbm","stop__label":"stop__label-4X3OV"};